import React from 'react';
import CheckboxesTreeStore from "../stores/checkboxes-tree-store";
import {observer} from 'mobx-react-lite';
import CheckboxesTreeItem from './checkboxes-tree-item/checkboxes-tree-item';

export interface INestedCheckboxItemProps {
    store: CheckboxesTreeStore;
}

/**
 * Renders root nodes of the nested list. Each node is an observer component
 * (NestedCheckboxItem) to keep rerenders localized per subtree during filter/expand/selection.
 */
const CheckboxesTreeItems: React.FC<INestedCheckboxItemProps> = observer(({store}) => {
    return (
        <>
            {store.getItems().map((storeItem) => (
                    <CheckboxesTreeItem
                        key={storeItem.pathIndex()}
                        itemStore={storeItem}
                        listStore={store}
                    />
                ))
            }
        </>
    );
});

export default CheckboxesTreeItems;
